export default __webpack_public_path__ + "static/media/AXIA_menubar_logo.d8211b67.png";